import { apiClient } from "../utils/apiClient";
import { ORGANIZER_ORDERS_URL } from "../config/api";
import { OrderStatus, PaymentProvider } from "./orderService";

// Why the order needs the organizer (ms-payments-integration, docs/orders-under-review-decision.md)
export type ReviewType = 'LATE_PAYMENT' | 'DUPLICATE_PAYMENT' | 'AMOUNT_MISMATCH' | 'PAYMENT_REVERSED' | 'FULFILLMENT_FAILED';

export type ReviewAction = 'ISSUE_TICKETS' | 'MARK_REFUNDED' | 'MARK_RESOLVED';

export interface OrderUnderReview {
    orderId: string;
    reference: string;
    eventId: string;
    eventName?: string;
    orderStatus: OrderStatus;
    reviewType?: ReviewType;
    // Technical detail, in English
    reviewReason?: string;
    buyerEmail: string;
    buyerPhone?: string;
    amount: number;
    currency?: string;
    provider?: PaymentProvider;
    transactionId?: string;
    createdAt: string;
    paidAt?: string;
    ticketsIssued: boolean;
    // The tickets went back to the stock when the reservation expired
    stockReleased: boolean;
    items: Array<{ stageName?: string; quantity: number; unitPrice?: number }>;
    // What the organizer can do now; the backend enforces the same rules
    allowedActions: ReviewAction[];
}

export class ReviewResolutionError extends Error {
    constructor(public readonly status: number, message: string) {
        super(message);
        this.name = 'ReviewResolutionError';
    }
}

export const organizerOrdersService = {
    async getOrdersUnderReview(): Promise<OrderUnderReview[]> {
        const response = await apiClient(`${ORGANIZER_ORDERS_URL}/review`, { cache: 'no-store' });
        if (!response.ok) {
            throw new Error('No fue posible consultar las órdenes en revisión');
        }
        return await response.json();
    },

    // 404: not under review anymore; 409: the action no longer fits; 503: the stock could not be returned
    async resolve(orderId: string, action: ReviewAction): Promise<OrderUnderReview> {
        const response = await apiClient(`${ORGANIZER_ORDERS_URL}/${encodeURIComponent(orderId)}/resolve`, {
            method: 'POST',
            body: JSON.stringify({ action })
        });
        if (!response.ok) {
            throw new ReviewResolutionError(response.status, 'No fue posible resolver la orden');
        }
        return await response.json();
    }
};
